var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OverviewActions',{attrs:{"type":"subscriptions","item-id":_vm.subscription.id,"info":"","edit":"","remove":"","disable-remove":_vm.isSubscriptionPending},on:{"onRemove":_vm.removeSubscription}})}
var staticRenderFns = []

export { render, staticRenderFns }